// extracted by mini-css-extract-plugin
export default {"upsellWrapper":"pS","backgroundimage":"qS","header":"rS","headerwrap":"sS","title":"tS","promomessage":"uS","upsellItem":"vS","upsellImg":"wS","helperText":"xS","upsellHeadline":"yS","price":"zS","upsellGross":"AS","upsellNet":"BS","upsellButton":"CS","nutritionfacts":"ES","nutritionimg":"FS","containerwhy":"GS","nutritionwrappwer":"HS","headlinewhy":"IS","boxwhy":"JS","textwhy":"KS","backbutton":"LS","drawercontainer":"MS","logoheader":"NS","textwrap":"OS","timer":"PS"};
    if(module.hot) {
      // 1714654898479
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  